import { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Scissors, ArrowLeft, Star, Loader2, CheckCircle2 } from "lucide-react";

export default function TestimonialPage() {
  const [name, setName] = useState("");
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/public/testimonial", { name, rating, comment }); setDone(true); }
    catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0f0f0f] text-[#f5f5f5]">
      <header className="border-b border-[#2a2a2a] h-16 flex items-center px-5">
        <Link to="/" className="flex items-center gap-2 text-[#a3a3a3]"><ArrowLeft className="w-4 h-4" /><Scissors className="w-5 h-5 text-[#d4af37]" /><span className="font-bold">NAKAMA</span></Link>
      </header>
      <div className="max-w-md mx-auto px-5 py-10">
        {done ? (
          <div className="text-center py-10" data-testid="testimonial-done">
            <CheckCircle2 className="w-16 h-16 text-[#16a34a] mx-auto mb-4" />
            <h1 className="text-2xl font-extrabold">¡Gracias por tu reseña!</h1>
            <p className="text-[#a3a3a3] mt-2">Será publicada tras aprobación del equipo.</p>
            <Link to="/" className="nk-btn inline-block mt-6">Volver al inicio</Link>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-extrabold mb-1">Deja tu reseña</h1>
            <p className="text-[#a3a3a3] text-sm mb-6">Cuéntanos tu experiencia en Barbería Nakama.</p>
            <form onSubmit={submit} className="space-y-5">
              <input className="nk-input" placeholder="Tu nombre" value={name} onChange={(e) => setName(e.target.value)} required data-testid="testimonial-name" />
              <div>
                <label className="text-sm text-[#a3a3a3] mb-2 block">Calificación</label>
                <div className="flex gap-1">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <button type="button" key={n} onClick={() => setRating(n)} data-testid={`star-${n}`}>
                      <Star className={`w-8 h-8 ${n <= rating ? "text-[#d4af37] fill-[#d4af37]" : "text-[#2a2a2a]"}`} />
                    </button>
                  ))}
                </div>
              </div>
              <textarea className="nk-input" rows={4} placeholder="Tu comentario..." value={comment} onChange={(e) => setComment(e.target.value)} required data-testid="testimonial-comment" />
              <button disabled={loading} className="nk-btn w-full flex items-center justify-center gap-2" data-testid="testimonial-submit">
                {loading && <Loader2 className="w-4 h-4 animate-spin" />}Enviar reseña
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
